<template>
    <v-app>
    <v-container>
     <matchComponent class="mb-10" />
    </v-container>
    </v-app>
</template>


<script>

import matchComponent from '../views/matchPage/matchComponent.vue'
export default {
    components : {matchComponent},
    methods : {
    }
};
</script>
